import React, { useCallback } from "react";
import get from "lodash/get";
import cx from "classnames";
import { useRillContext } from "../../rill/RillReact/share/base";

function ToggleLinks({
  name,
  options,
  defaultActive,
  className,
  callback = () => {},
  rawStyle = false,
  activePrimary,
  children,
}) {
  const {
    locals: { query = {}, path },
  } = useRillContext();

  const active = defaultActive || get(query, name);

  const handleClick = useCallback(
    (value) => {
      callback(value);
    },
    [callback]
  );

  return (
    <ul role="toggle-links" className={className || undefined}>
      <input type="hidden" name={name} value={active} />
      {options.map(({ value, text, href, IconImg = "", dataStatus }) => {
        const searchString = `${encodeURIComponent(name)}=${encodeURIComponent(
          value
        )}`;

        const newHref = href ? href : `/actions/refresh?${searchString}`;
        return (
          <a
            key={value}
            onClick={handleClick}
            href={newHref}
            data-button-type={
              (
                href
                  ? path === href || value === active
                  : query[name]
                  ? path.includes(searchString) || value === query[name]
                  : value === active || path.includes(searchString)
              )
                ? activePrimary
                  ? "primary"
                  : "outline"
                : "secondary"
            }
            className={cx(`value-${rawStyle ? "test" : value}`, {
              active: href
                ? path === href || value === active
                : query[name]
                ? path.includes(searchString) || value === query[name]
                : value === active || path.includes(searchString),
            })}
            role="button"
            data-status={dataStatus}
          >
            {IconImg && IconImg}
            {text}
          </a>
        );
      })}
      {children}
    </ul>
  );
}

export default ToggleLinks;
